import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import './List.css';
import '../App.css';
import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { getSharedPictureListByUrl } from '../apicalls/cloud/sharePicture';
import { guestLogin } from '../apicalls/cloud/guestLogin';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import { FolderField } from '../components/sharePictureListPage/FolderField';
import type { TSharedPictureList } from '../types/cloudStorage/CloudFileList';

export const SharePictureListPage: React.FC = () => {
  // 共有されている写真
  const [sharedPictureList, setSharedPictureList] =
    useState<TSharedPictureList | undefined>();

  // エラーメッセージ表示フラグ
  const [isError, setIsError] = useState(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState('');

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsError(false);
  };

  // URLのuidとpwdを取得
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const uid = query.get('uid') as string;
  const pwd = query.get('pwd') as string;

  const getSharedPictureList = () => {
    getSharedPictureListByUrl(uid, pwd).then(res => {
      setSharedPictureList(res.data);
      if (res.error) {
        setIsError(true);
        setErrorMessage(res.error);
      }
    });
  };

  useEffect(() => {
    guestLogin(uid, pwd) // 共有先を認証し、アクセストークンをセット
      .then(res => {
        getSharedPictureList(); // 共有先リスト取得
        if (res.data.error) {
          setIsError(true);
          setErrorMessage(res.data.error);
        }
      });
  }, [uid, pwd]);

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <div style={{ backgroundColor: '#F5F5F5' }}>
        {/* ヘッダー */}
        <AppBarComponent isSharePage={true} />

        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 120
          }}
        >
          {sharedPictureList && (
            <FolderField
              sharedPictureList={sharedPictureList}
              getSharedPictureList={getSharedPictureList}
            />
          )}
        </div>

        {/* フッター */}
        <FooterComponent />
      </div>

      {/* エラーメッセージ */}
      {/* MUIのSnackbar ※notistack（ライブラリ）のSnackbarProviderは無関係 */}
      <Snackbar open={isError} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>
    </SnackbarProvider>
  );
};
